import {
  GetOfferPublishedParticipants,
  GetOfferPublishedParticipantsVariables,
} from "_graphql/queries/__generated__/GetOfferPublishedParticipants";
import {
  PublishedOffers,
  PublishedOffersVariables,
} from "_graphql/queries/__generated__/PublishedOffers";
import {
  getOfferPublishedParticipants,
  getPublishedOffers,
  getPublishedOffersCount,
} from "_graphql/visal/queries/publish-offers";

import { OfferStatus } from "_graphql/__generated__/globalTypes";
import { useQuery } from "@apollo/client";

export const usePublishedOffers = (
  variables?: Partial<PublishedOffersVariables>
) => {
  const {
    offerStatus = OfferStatus.OPEN,
    limit = 10,
    offset = 0,
  } = variables || {};

  const { data, ...rest } = useQuery<PublishedOffers, PublishedOffersVariables>(
    getPublishedOffers,
    {
      variables: {
        offerStatus,
        limit,
        offset,
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "network-only",
    }
  );

  return {
    publishedOffers: data?.publishedOffers || [],
    ...rest,
  };
};

export const usePublishedOffersCount = (
  variables?: Partial<PublishedOffersVariables>
) => {
  const { offerStatus = OfferStatus.OPEN, limit, offset } = variables || {};

  const { data, ...rest } = useQuery(getPublishedOffersCount, {
    variables: {
      offerStatus,
      limit,
      offset,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  return {
    count: data?.publishedOffersCount || 0,
    ...rest,
  };
};

export interface OfferPublishedParticipantsVariables {
  offerId: string;
}

export const useOfferPublishedParticipants = (
  variables: OfferPublishedParticipantsVariables
) => {
  const { data, ...rest } = useQuery<
    GetOfferPublishedParticipants,
    GetOfferPublishedParticipantsVariables
  >(getOfferPublishedParticipants, {
    variables,
    // notifyOnNetworkStatusChange: true,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
  });

  return {
    participants: data?.getOfferPublishedParticipants || [],
    ...rest,
  };
};

export const usePublishedOffersPaginated = (
  variables?: Partial<PublishedOffersVariables> & {
    page?: number;
    pageSize?: number;
  }
) => {
  const {
    offerStatus = OfferStatus.OPEN,
    page = 1,
    pageSize = 10,
  } = variables || {};

  const offset = (page - 1) * pageSize;

  const { data: offersData, ...rest } = useQuery<
    PublishedOffers,
    PublishedOffersVariables
  >(getPublishedOffers, {
    variables: {
      offerStatus,
      limit: pageSize,
      offset,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  return {
    publishedOffers: offersData?.publishedOffers || [],
    totalCount: offersData?.publishedOffersCount || 0,
    ...rest,
  };
};

export interface MessageType {
  uuid: string;
  message: string;
  timeStamp: string;
  sender_name: string;
  state?: string;
}
